import { Text } from "@/components/Text";
import { Badge } from "@/components/ui/badge";
import { SkillType } from "@/types";

export const Skill = ({ skill }: { skill: SkillType }) => {
  /* Render */
  const render = () => {
    return (
      <Badge
        className="border-slate-200 bg-slate-50 text-slate-700"
        variant="outline"
      >
        <Text className="text-xs font-medium text-slate-700">{skill.name}</Text>
      </Badge>
    );
  };

  return render();
};
